import React, { useEffect, useState } from "react";
import { Button, Modal } from "@ts-digital/vrc";
import VaporContentSwitcher from "../../../vapor/contentSwitcher";
import "../style.css";
import SplitArticleRow from "./splitArticleRow";
import { useDispatch } from "react-redux";
import { getDetailAccounts } from "../../../../store/actions/precog";
import { Tooltip } from "antd";
import { splitAccountingLine } from "../../../../store/actions/precog/accountingLines";
import { getVatLines } from "../../../../store/actions/precog/vat";

const SplitArticleModal = ({
  setOpenSplitModal,
  article,
  visible,
  currentConto,
  contiNew,
  draftId,
  changeArticle,
  isMonoRegime,
  setExpandedRow,
  isDocument,
  articlesList,
  setArticlesList,
  setModifiedDetail
}) => {
  const dispatch = useDispatch();
  const [tabSelected, setTabSelected] = useState("amount");
  const [isDebit, setIsDebit] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  
  useEffect(() => {
    if (!article || !currentConto) return;
    setTotalAmount(article.debit !== 0 ? article.debit : article.credit);
    setIsDebit(article.debit !== 0);
    setArticlesList([{ ...article, accountDesc: currentConto?.accountDesc, accountCode: currentConto?.accountCode, accountUuid: currentConto?.uuid }]);
  }, [article, currentConto]);

  const saveArticles = () => {
    const createBodyList = [];
    const updateIdList = [];
    let updateBody = {};
    articlesList.map((el, idx) => {
      if (idx !== 0) {
        createBodyList.push(el);
      } else {
        updateIdList.push(article.uuid);
        updateBody = isDebit ? {debit: totalAmount} : {credit: totalAmount};
      }
    });
    const objToSend = {createBodyList: createBodyList, updateIdList: updateIdList, updateBody: updateBody};
    dispatch(splitAccountingLine(draftId, objToSend)).then(() => {
      dispatch(getDetailAccounts(draftId)).then(() => {
        dispatch({ type: "SET_ACCOUNTS_REFRESH" });
        setOpenSplitModal(false);
      });
    });
    dispatch(getVatLines(draftId));
  };
  
  return (
    <Modal
      visible={true}
      closable={true}
      backdrop={false}
      onClose={() => {
        setOpenSplitModal(false);
      }}
      footer={
        <div className="split-article-footer">
          <div style={{display: "flex", gap: 12}}>
            <Button
              kind="secondary"
              onClick={() => {
                setOpenSplitModal(false);
              }}
            >
              Annulla
            </Button>
            <Tooltip
              color={"rgb(0, 80, 117)"}
              placement="top"
              title={totalAmount <= 0 ? "L'importo del primo articolo non può essere uguale o inferiore a zero" : ""}
              trigger="hover"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <div>
                <Button
                  disabled={totalAmount <= 0}
                  kind="primary"
                  onClick={() => {
                    saveArticles();
                  }}
                >
                  Salva
                </Button>
              </div>
            </Tooltip>
          </div>
        </div>
      }
      title="Fraziona articoli"
    >
      <div className="split-article-content">
        <div className="split-article-subtitle">
              Puoi separare gli articoli se hanno aliquote, destinazioni diverse o spostarne una parte in altri conti
        </div>
        <div className="split-article-desc">
          {article.articleDesc}
        </div>
        <div>
          <VaporContentSwitcher
            selected={tabSelected}
            itemsWidth={100}
            onChange={val => setTabSelected(val)}
            items={[
              { value: "amount", label: "Importo" },
              { value: "quantity", label: "Quantità" }
            ]}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 25 }}>
          {articlesList.map((el, index) => {
            return <SplitArticleRow
              setModifiedDetail={setModifiedDetail}
              key={index}
              currentArticle={el}
              currentConto={currentConto}
              contiNew={contiNew}
              draftId={draftId}
              articlesList={articlesList}
              setArticlesList={setArticlesList}
              changeArticle={changeArticle}
              isDebit={isDebit}
              index={index}
              totalAmount={totalAmount}
              isMonoRegime={isMonoRegime}
              setTotalAmount={setTotalAmount}
              isDocument={isDocument}
            />;
          })}
        </div>
      </div>
    </Modal>
  );
};

export default SplitArticleModal; 
